import PDFAcroChoice from './PDFAcroChoice.js';
import { PDFClasses } from '../../api/objects.js';
class PDFAcroListBox extends PDFAcroChoice {
    myClass() {
        return PDFClasses.PDFAcroListBox;
    }
}
PDFAcroListBox.className = () => PDFClasses.PDFAcroListBox;
PDFAcroListBox.fromDict = (dict, ref) => new PDFAcroListBox(dict, ref);
PDFAcroListBox.create = (context) => {
    const dict = context.obj({
        FT: 'Ch',
        Kids: [],
    });
    const ref = context.register(dict);
    return new PDFAcroListBox(dict, ref);
};
export default PDFAcroListBox;
//# sourceMappingURL=PDFAcroListBox.js.map